// *** UPDATED: Header Component ***
import { Menu } from 'lucide-react';

interface HeaderProps {
    title: string;
    onToggleSidebar: () => void;
}

export function Header({ title, onToggleSidebar }: HeaderProps) {

    return (
        <header className={`h-16 bg-background shadow-sm flex items-center justify-between px-4 sm:px-6 flex-shrink-0 relative z-10`}>
            <div className="flex items-center">
                {/* Mobile Menu Button */}
                <button
                    onClick={onToggleSidebar}
                    className="mr-3 p-2 rounded-md text-foreground hover:bg-secondary hover:text-muted lg:hidden focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
                    aria-label="Open sidebar"
                >
                    <Menu size={24} />
                </button>
                <h1 className={`text-lg sm:text-xl font-semibold text-foreground`}>
                    {title}
                </h1>
            </div>
        </header>
    );
}